import React from 'react';
import {
  Paper,
  Typography,
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  // Box // Temporarily unused - for marketing info
} from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const ReleaseDetails = ({ releaseData, setReleaseData }) => {
  const handleChange = (field, value) => {
    setReleaseData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // TEMPORARILY COMMENTED OUT - Marketing info handlers for future use
  // const handleMarketingChange = (field, value) => {
  //   setReleaseData(prev => ({
  //     ...prev,
  //     marketingInfo: {
  //       ...prev.marketingInfo,
  //       [field]: value
  //     }
  //   }));
  // };

  // Handle toggling the pre-save or pre-order features
  // const handleMarketingToggle = (field) => (event) => {
  //   setReleaseData(prev => ({
  //     ...prev,
  //     marketingInfo: {
  //       ...prev.marketingInfo,
  //       [`${field}Enabled`]: event.target.checked,
  //       // If turning off, clear the date
  //       [field]: event.target.checked ? prev.marketingInfo[field] || new Date() : null
  //     }
  //   }));
  // };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Release Details
      </Typography>

      <Grid container spacing={3}>
        {/* Release Year */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Release Year"
            type="number"
            value={releaseData.releaseYear}
            onChange={(e) => handleChange('releaseYear', Number(e.target.value))}
            InputProps={{
              inputProps: {
                min: 1900,
                max: new Date().getFullYear() + 10
              }
            }}
            required
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': { borderColor: '#666666' },
                '&:hover fieldset': { borderColor: '#666666' },
                '&.Mui-focused fieldset': { borderColor: '#a187f2' }
              }
            }}
          />
        </Grid>

        {/* Catalog Number */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Catalog Number"
            value={releaseData.catalogNumber || ''}
            onChange={(e) => handleChange('catalogNumber', e.target.value)}
            helperText="Optional. Leave blank if you don't have a catalog number"
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': { borderColor: '#666666' },
                '&:hover fieldset': { borderColor: '#666666' },
                '&.Mui-focused fieldset': { borderColor: '#a187f2' }
              }
            }}
          />
        </Grid>

        {/* Release Description */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Release Description"
            multiline
            rows={4}
            value={releaseData.description || ''}
            onChange={(e) => handleChange('description', e.target.value)}
            helperText="Optional. Provide context for your release"
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': { borderColor: '#666666' },
                '&:hover fieldset': { borderColor: '#666666' },
                '&.Mui-focused fieldset': { borderColor: '#a187f2' }
              }
            }}
          />
        </Grid>

        {/* Explicit Content Flag */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={releaseData.explicit}
                onChange={(e) => handleChange('explicit', e.target.checked)}
              />
            }
            label="This release contains explicit content"
          />
        </Grid>

        {/* Marketing Information - TEMPORARILY HIDDEN */}
        {/* 
        <Grid item xs={12}>
          <Typography variant="subtitle2" gutterBottom sx={{ mt: 2 }}>
            Marketing Timeline
          </Typography>
          <Box sx={{ py: 2 }}>
            <Grid container spacing={3}>
              {/* Pre-save Date with toggle */}
              {/* <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={releaseData.marketingInfo.preSaveDateEnabled || false}
                      onChange={handleMarketingToggle('preSaveDate')}
                    />
                  }
                  label="Enable Pre-save"
                />
                
                {releaseData.marketingInfo.preSaveDateEnabled && (
                  <Box sx={{ mt: 2 }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="Pre-save Date"
                        value={releaseData.marketingInfo.preSaveDate || null}
                        onChange={(date) => handleMarketingChange('preSaveDate', date)}
                        renderInput={(params) => 
                          <TextField 
                            {...params} 
                            fullWidth 
                            helperText="When to enable pre-saves"
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                '& fieldset': { borderColor: '#666666' },
                                '&:hover fieldset': { borderColor: '#666666' },
                                '&.Mui-focused fieldset': { borderColor: '#a187f2' }
                              }
                            }}
                          />
                        }
                        minDate={new Date()}
                        maxDate={releaseData.releaseDate || undefined}
                      />
                    </LocalizationProvider>
                  </Box>
                )}
              </Grid> */}

              {/* Pre-order Date with toggle */}
              {/* <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={releaseData.marketingInfo.preOrderDateEnabled || false}
                      onChange={handleMarketingToggle('preOrderDate')}
                    />
                  }
                  label="Enable Pre-order"
                />
                
                {releaseData.marketingInfo.preOrderDateEnabled && (
                  <Box sx={{ mt: 2 }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="Pre-order Date"
                        value={releaseData.marketingInfo.preOrderDate || null}
                        onChange={(date) => handleMarketingChange('preOrderDate', date)}
                        renderInput={(params) => 
                          <TextField 
                            {...params} 
                            fullWidth 
                            helperText="When to start pre-orders"
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                '& fieldset': { borderColor: '#666666' },
                                '&:hover fieldset': { borderColor: '#666666' },
                                '&.Mui-focused fieldset': { borderColor: '#a187f2' }
                              }
                            }}
                          />
                        }
                        minDate={new Date()}
                        maxDate={releaseData.releaseDate || undefined}
                      />
                    </LocalizationProvider>
                  </Box>
                )}
              </Grid> */}

              {/* <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Marketing Notes"
                  multiline
                  rows={3}
                  value={releaseData.marketingInfo.marketingNotes || ''}
                  onChange={(e) => handleMarketingChange('marketingNotes', e.target.value)}
                  helperText="Optional. Add any specific marketing plans or requirements"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: '#666666' },
                      '&:hover fieldset': { borderColor: '#666666' },
                      '&.Mui-focused fieldset': { borderColor: '#a187f2' }
                    }
                  }}
                />
              </Grid> */}
            {/* </Grid>
          </Box>
        </Grid> */}

        {/* Release Date */}
        <Grid item xs={12} md={6}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Release Date"
              value={releaseData.releaseDate}
              onChange={(date) => handleChange('releaseDate', date || new Date())}
              renderInput={(params) => 
                <TextField 
                  {...params} 
                  fullWidth 
                  required
                  error={!releaseData.releaseDate || isNaN(new Date(releaseData.releaseDate).getTime())}
                  helperText={(!releaseData.releaseDate || isNaN(new Date(releaseData.releaseDate).getTime())) 
                    ? "Please select a valid release date" 
                    : "Select your planned release date"}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: '#666666' },
                      '&:hover fieldset': { borderColor: '#666666' },
                      '&.Mui-focused fieldset': { borderColor: '#a187f2' }
                    }
                  }}
                />
              }
              minDate={new Date()}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ReleaseDetails;